import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AboutBoxProperties } from './about-box-types.js';
class AboutBoxAPI extends ComponentAPI {
    /**
     * Obtains the caution icon.
     */
    getCautionIcon() {
        return this.state.cautionIcon ?? AboutBoxProperties.cautionIcon.defaultValue;
    }
    /**
    * Sets the caution icon.
    *
    * @param cautionIcon - The caution icon.
    */
    setCautionIcon(cautionIcon) {
        this.setState({ cautionIcon });
    }
    /**
     * Obtains the company address
     */
    getCompanyAddress() {
        return this.state.companyAddress ?? AboutBoxProperties.companyAddress.defaultValue;
    }
    /**
     * Updates the company address
     *
     * @param companyAddress - The company address
     */
    setCompanyAddress(companyAddress) {
        this.setState({ companyAddress });
    }
    /**
     * Obtains the company address icon.
     */
    getCompanyAddressIcon() {
        return this.state.companyAddressIcon ?? AboutBoxProperties.companyAddressIcon.defaultValue;
    }
    /**
    * Sets the company address icon.
    *
    * @param companyAddressIcon - The company address icon.
    */
    setCompanyAddressIcon(companyAddressIcon) {
        this.setState({ companyAddressIcon });
    }
    /**
     * Obtains the company address outline icon.
     */
    getCompanyAddressOutlineIcon() {
        return this.state.companyAddressOutlineIcon ?? AboutBoxProperties.companyAddressOutlineIcon.defaultValue;
    }
    /**
    * Sets the company address outline icon.
    *
    * @param companyAddressOutlineIcon - The company address outline icon.
    */
    setCompanyAddressOutlineIcon(companyAddressOutlineIcon) {
        this.setState({ companyAddressOutlineIcon });
    }
    /**
     * Obtains the company complementary address
     */
    getCompanyComplementaryAddress() {
        return this.state.companyComplementaryAddress ?? AboutBoxProperties.companyComplementaryAddress.defaultValue;
    }
    /**
     * Updates the company complementary address
     *
     * @param companyComplementaryAddress - The company complementary address
     */
    setCompanyComplementaryAddress(companyComplementaryAddress) {
        this.setState({ companyComplementaryAddress });
    }
    /**
     * Obtains the company reference
     */
    getCompanyReference() {
        return this.state.companyReference ?? AboutBoxProperties.companyReference.defaultValue;
    }
    /**
     * Updates the company reference
     *
     * @param companyReference - The company reference
     */
    setCompanyReference(companyReference) {
        this.setState({ companyReference });
    }
    /**
     * Obtains the company reference icon
     */
    getCompanyReferenceIcon() {
        return this.state.companyReferenceIcon ?? AboutBoxProperties.companyReferenceIcon.defaultValue;
    }
    /**
     * Updates the company reference icon
     *
     * @param companyReferenceIcon - The company reference icon
     */
    setCompanyReferenceIcon(companyReferenceIcon) {
        this.setState({ companyReferenceIcon });
    }
    /**
     * Define an list of custom icons
     * @param customIcons - List of custom icons
     */
    setCustomIcons(customIcons) {
        this.setState({ customIcons });
    }
    /**
     * Obtains an list of custom icons
     */
    getCustomIcons() {
        return this.state.customIcons ?? AboutBoxProperties.customIcons.defaultValue;
    }
    /**
     * Obtains the logo icon.
     */
    getLogoIcon() {
        return this.state.logoIcon ?? AboutBoxProperties.logoIcon.defaultValue;
    }
    /**
    * Sets the logo icon.
    *
    * @param logoIcon - The logo icon.
    */
    setLogoIcon(logoIcon) {
        this.setState({ logoIcon });
    }
    /**
     * Obtains the LOT number icon.
     */
    getLotNumberIconIcon() {
        return this.state.lotNumberIcon ?? AboutBoxProperties.lotNumberIcon.defaultValue;
    }
    /**
    * Sets the LOT icon.
    *
    * @param lotNumberIcon - The LOT icon.
    */
    setLOTIcon(lotNumberIcon) {
        this.setState({ lotNumberIcon });
    }
    /**
     * Obtains the message expression
     */
    getMessageExpression() {
        return this.state.messageExpression ?? AboutBoxProperties.messageExpression.defaultValue;
    }
    /**
     * Updates the message expression
     *
     * @param messageExpression - The message expression
     */
    setMessageExpression(messageExpression) {
        this.setState({ messageExpression });
    }
    /**
     * Obtains the product expression
     */
    getProductExpression() {
        return this.state.productExpression;
    }
    /**
     * Updates the product expression
     *
     * @param productExpression - The product expression
     */
    setProductExpression(productExpression) {
        this.setState({ productExpression });
    }
    /**
     * Obtains the product name
     */
    getProductName() {
        return this.state.productName ?? AboutBoxProperties.productName.defaultValue;
    }
    /**
     * Updates the product name
     *
     * @param productName - The product name
     */
    setProductName(productName) {
        this.setState({ productName });
    }
    /**
     * Obtains the product subtitle
     */
    getProductSubtitle() {
        return this.state.productSubtitle ?? AboutBoxProperties.productSubtitle.defaultValue;
    }
    /**
     * Updates the product subtitle
     *
     * @param productSubtitle - The product subtitle
     */
    setProductSubtitle(productSubtitle) {
        this.setState({ productSubtitle });
    }
    /**
     * Obtains the quantity icon.
     */
    getQuantityIcon() {
        return this.state.quantityIcon ?? AboutBoxProperties.quantityIcon.defaultValue;
    }
    /**
    * Sets the quantity icon.
    *
    * @param quantityIcon - The quantity icon.
    */
    setQuantityIcon(quantityIcon) {
        this.setState({ quantityIcon });
    }
    /**
     * Obtains the reference icon.
     */
    getReferenceIcon() {
        return this.state.referenceIcon ?? AboutBoxProperties.referenceIcon.defaultValue;
    }
    /**
    * Sets the reference icon.
    *
    * @param referenceIcon - The reference icon.
    */
    setReferenceIcon(referenceIcon) {
        this.setState({ referenceIcon });
    }
    /**
     * Obtains the secondary message expression
     */
    getSecondaryMessageExpression() {
        return this.state.secondaryMessageExpression ?? AboutBoxProperties.secondaryMessageExpression.defaultValue;
    }
    /**
     * Updates the secondary message expression
     *
     * @param secondaryMessageExpression - The secondary message expression
     */
    setSecondaryMessageExpression(secondaryMessageExpression) {
        this.setState({ secondaryMessageExpression });
    }
    /**
     * Obtains if the quantity icon is visible
     */
    isShowQuantity() {
        return this.state.showQuantity ?? AboutBoxProperties.showQuantity.defaultValue;
    }
    /**
     * Updates if the quantity icon is visible
     *
     * @param showQuantity - If the quantity icon is visible
     */
    setShowQuantity(showQuantity) {
        this.setState({ showQuantity });
    }
    /**
     * Obtains the unique device identifier icon
     */
    getUniqueDeviceIdentifierIcon() {
        return this.state.uniqueDeviceIdentifierIcon ?? AboutBoxProperties.uniqueDeviceIdentifierIcon.defaultValue;
    }
    /**
    * Sets the unique device identifier icon
    *
    * @param uniqueDeviceIdentifierIcon - The unique device identifier icon
    */
    setUniqueDeviceIdentifierIcon(uniqueDeviceIdentifierIcon) {
        this.setState({ uniqueDeviceIdentifierIcon });
    }
    /**
     * Obtains the version expression
     */
    getVersionExpression() {
        return this.state.versionExpression ?? AboutBoxProperties.versionExpression.defaultValue;
    }
    /**
     * Updates the version expression
     *
     * @param versionExpression - The version expression
     */
    setVersionExpression(versionExpression) {
        this.setState({ versionExpression });
    }
}
export { AboutBoxAPI, };
//# sourceMappingURL=about-box-api.js.map